import type { SVGProps } from "react";

export function UserIdVerificationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.85074 1.875C4.85104 1.92056 3.68302 2.11092 2.88498 2.9062C2.18653 3.60223 1.95305 4.58067 1.875 6.15M11.1493 1.875C13.149 1.92056 14.317 2.11092 15.115 2.9062C15.8135 3.60223 16.047 4.58067 16.125 6.15M11.1493 16.125C13.149 16.0794 14.317 15.889 15.115 15.0938C15.8135 14.3977 16.047 13.4193 16.125 11.85M6.85074 16.125C4.85104 16.0794 3.68302 15.889 2.88498 15.0938C2.18653 14.3977 1.95305 13.4193 1.875 11.85"
        stroke="#4A5466"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 12.75C7.37378 10.9184 10.6075 10.8321 12.375 12.75M10.8713 7.125C10.8713 8.16052 10.0306 9 8.99368 9C7.95665 9 7.11598 8.16052 7.11598 7.125C7.11598 6.08947 7.95665 5.25 8.99368 5.25C10.0306 5.25 10.8713 6.08947 10.8713 7.125Z"
        stroke="#4A5466"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  );
}
